namespace $ { export class $piterjs_meetup_page extends $mol_page {

	/**
	 *  ```
	 *  meetup $piterjs_meetup
	 *  ```
	 **/
	@ $mol_mem
	meetup() {
		return (( obj )=>{
			return obj
		})( new this.$.$piterjs_meetup(  ) )
	}

	/**
	 *  ```
	 *  tools /
	 *  	<= Date
	 *  	<= Close
	 *  ```
	 **/
	tools() {
		return [this.Date() , this.Close()] as readonly any[]
	}

	/**
	 *  ```
	 *  Date $mol_view sub / <= date
	 *  ```
	 **/
	@ $mol_mem
	Date() {
		return (( obj )=>{
			obj.sub = () => [this.date()] as readonly any[]
			return obj
		})( new this.$.$mol_view(  ) )
	}

	/**
	 *  ```
	 *  date \
	 *  ```
	 **/
	date() {
		return ""
	}

	/**
	 *  ```
	 *  Close $mol_link
	 *  	arg *
	 *  		meetup null
	 *  		speech null
	 *  		place null
	 *  		video null
	 *  	sub / <= Close_icon
	 *  ```
	 **/
	@ $mol_mem
	Close() {
		return (( obj )=>{
			obj.arg = () => ({
			"meetup" :  null as any ,
			"speech" :  null as any ,
			"place" :  null as any ,
			"video" :  null as any ,
		})
			obj.sub = () => [this.Close_icon()] as readonly any[]
			return obj
		})( new this.$.$mol_link(  ) )
	}

	/**
	 *  ```
	 *  Close_icon $mol_icon_cross
	 *  ```
	 **/
	@ $mol_mem
	Close_icon() {
		return (( obj )=>{
			return obj
		})( new this.$.$mol_icon_cross(  ) )
	}

	/**
	 *  ```
	 *  body /
	 *  	<= Description
	 *  	<= Links
	 *  	<= Speeches
	 *  ```
	 **/
	body() {
		return [this.Description() , this.Links() , this.Speeches()] as readonly any[]
	}

	/**
	 *  ```
	 *  Description $mol_text text <= description
	 *  ```
	 **/
	@ $mol_mem
	Description() {
		return (( obj )=>{
			obj.text = () => this.description()
			return obj
		})( new this.$.$mol_text(  ) )
	}

	/**
	 *  ```
	 *  description \
	 *  ```
	 **/
	description() {
		return ""
	}

	/**
	 *  ```
	 *  Links $mol_view sub <= links
	 *  ```
	 **/
	@ $mol_mem
	Links() {
		return (( obj )=>{
			obj.sub = () => this.links()
			return obj
		})( new this.$.$mol_view(  ) )
	}

	/**
	 *  ```
	 *  links /
	 *  	<= Video
	 *  	<= Place
	 *  ```
	 **/
	links() {
		return [this.Video() , this.Place()] as readonly any[]
	}

	/**
	 *  ```
	 *  Video $mol_link
	 *  	arg *
	 *  		video \
	 *  		place null
	 *  		speech null
	 *  	title \Трансляция
	 *  ```
	 **/
	@ $mol_mem
	Video() {
		return (( obj )=>{
			obj.arg = () => ({
			"video" :  "" ,
			"place" :  null as any ,
			"speech" :  null as any ,
		})
			obj.title = () => "Трансляция"
			return obj
		})( new this.$.$mol_link(  ) )
	}

	/**
	 *  ```
	 *  Place $mol_link
	 *  	arg *
	 *  		video null
	 *  		place \
	 *  		speech null
	 *  	title \Площадка
	 *  ```
	 **/
	@ $mol_mem
	Place() {
		return (( obj )=>{
			obj.arg = () => ({
			"video" :  null as any ,
			"place" :  "" ,
			"speech" :  null as any ,
		})
			obj.title = () => "Площадка"
			return obj
		})( new this.$.$mol_link(  ) )
	}

	/**
	 *  ```
	 *  Speeches $mol_list rows <= speeches
	 *  ```
	 **/
	@ $mol_mem
	Speeches() {
		return (( obj )=>{
			obj.rows = () => this.speeches()
			return obj
		})( new this.$.$mol_list(  ) )
	}

	/**
	 *  ```
	 *  speeches /
	 *  ```
	 **/
	speeches() {
		return [] as readonly any[]
	}

	/**
	 *  ```
	 *  Speech!index $piterjs_speech_snippet speech <= speech!index
	 *  ```
	 **/
	@ $mol_mem_key
	Speech( index : any ) {
		return (( obj )=>{
			obj.speech = () => this.speech(index)
			return obj
		})( new this.$.$piterjs_speech_snippet(  ) )
	}

	/**
	 *  ```
	 *  speech!index $piterjs_speech
	 *  ```
	 **/
	@ $mol_mem_key
	speech( index : any ) {
		return (( obj )=>{
			return obj
		})( new this.$.$piterjs_speech(  ) )
	}

} }
